module.exports = __webpack_public_path__ + "static/img/vision.18bacbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/vision.png
// module id = Wc3v
// module chunks = 7